import { Component, ElementRef, Inject, inject, OnInit, signal, viewChild } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogClose, MatDialogRef } from '@angular/material/dialog';
import { FormInputComponent } from '../form-input/form-input.component';
import { ApiService, DialogService, FormService } from '../../../shared/services';
import { ExtendLicenseDto, License, PayloadRequest } from '../../../core/models';
import { LicenseService } from '../../../core/services';

@Component({
  selector: 'app-extend-license-dialog',
  imports: [
    MatDialogActions,
    MatDialogClose,
    MatButtonModule,
    FormsModule,
    ReactiveFormsModule,
    FormInputComponent
  ],
  templateUrl: './extend-license-dialog.component.html',
  styleUrl: './extend-license-dialog.component.scss'
})
export class ExtendLicenseDialogComponent implements OnInit {
  private formService = inject(FormService);
  private dialogService = inject(DialogService);
  private licenseService = inject(LicenseService);
  initialFocus = viewChild<ElementRef>('initialFocus');
  readonly dialogRef = inject(MatDialogRef<ExtendLicenseDialogComponent>);
  arrayLicenseSignal = signal<License[]>([])
  formExtendLicense = new FormGroup({});
  extendLicenseFormFields = signal<any>({
    expirationDate: {
      id: 'expirationDate',
      type: 'date',
      name: 'expirationDate',
      label: 'Data di scadenza',
      placeholder: "Inserire data di scadenza",
      value: '',
      data: [],
      validators: [Validators.required],
      errorMessages: {
        required: "Inserire la data di scadenza."
      }
    }
  })

  constructor(
  @Inject(MAT_DIALOG_DATA) public data: { arrayLicenseSignal: License[], onSubmitted?: () => void }
) {
  this.arrayLicenseSignal.set(data.arrayLicenseSignal);
}

  ngOnInit(): void {
    this.formExtendLicense = this.formService.createForm(this.extendLicenseFormFields());
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }

  onSubmit() {
    const arrLicenseIds = this.arrayLicenseSignal().map(license => license.licenseId);
    const extendLicenseDto: ExtendLicenseDto = {
      arrLicenseIds: arrLicenseIds,
      extendedDate: new Date(this.formExtendLicense.get('expirationDate')?.value!)
    };
    this.licenseService.extendLicenseExpirationDate(extendLicenseDto)
    .subscribe({
      next: () => {
        this.data.onSubmitted?.();
        this.dialogRef.close(true);
      },
      error: () => {
      }
    }
      
    );
  }
}
